import React, { useCallback, useEffect, useRef, useState } from 'react';
import Styles from './Accordion.css';

function Accordion({
  children,
  startOpen,
  title,
  defaultTextStyle,
  bottomSpace,
  alternateStyle,
  openTitle,
  onChange,
  accordionRef,
  dividerUp,
  whiteArrow,
}) {
  const [open, setOpen] = useState(startOpen || false);
  const ref = useRef();

  useEffect(() => {
    if (onChange) {
      onChange(open);
    }
  }, [onChange, open]);

  useEffect(() => {
    if (accordionRef) {
      accordionRef.current = {
        close,
        open,
        imperativeOpen,
        divRef: ref.current,
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const close = useCallback(() => {
    setOpen(false);
  }, []);

  const imperativeOpen = useCallback(() => {
    setOpen(true);
  }, []);

  return (
    <>
      <div
        ref={ref}
        className={[
          'custom-accordion',
          open ? 'opened' : '',
          bottomSpace ? 'mb-space' : '',
          alternateStyle ? 'alternate' : '',
          dividerUp ? 'divider-up' : '',
        ].join(' ')}
      >
        <div
          className="acc-header"
          onClick={(ev) => {
            ev.preventDefault();
            setOpen((o) => !o);
          }}
        >
          <h3
            className="acc-title"
            dangerouslySetInnerHTML={{ __html: open && openTitle ? openTitle : title }}
          />
          <span className="acc-btn">
            {whiteArrow ? (
              <img src="assets/premio-mais/ic_arrow_down.svg" alt="" />
            ) : (
              <img src="assets/seguro/arrow-right.svg" alt="" />
            )}
          </span>
        </div>
        <div className={['acc-body', defaultTextStyle ? 'default' : ' '].join(' ')}>{children}</div>
      </div>

      <style jsx>{Styles}</style>
    </>
  );
}

Accordion.defaultProps = {
  defaultTextStyle: true,
  bottomSpace: true,
  alternateStyle: false,
  onChange: () => {},
};

export default Accordion;
